<template>
  <div class="campaign-media" v-if="id">
    <span v-if="loading" class="small text-muted">Carregando mídia…</span>
    <span v-else-if="error" class="small text-muted">Prévia indisponível. A mídia permanece vinculada.</span>
    <img v-else-if="type === 'image' && url" :src="url" :alt="name || 'Imagem da campanha'">
    <video v-else-if="type === 'video' && url" :src="url" controls preload="metadata" />
    <a v-else-if="url" :href="url" :download="name || 'documento.pdf'">📎 {{ name || 'Abrir documento PDF' }}</a>
  </div>
</template>
<script>
import api from '../../config/axios';
export default {
  props: { id: [Number, String], type: String, name: String },
  data: () => ({ url: '', error: false, loading: false, requestVersion: 0 }),
  watch: { id: { immediate: true, handler() { this.load(); } } },
  beforeUnmount() { this.requestVersion++; if (this.url) URL.revokeObjectURL(this.url); },
  methods: { async load() {
    const version = ++this.requestVersion;
    if (this.url) URL.revokeObjectURL(this.url);
    this.url = ''; this.error = false;
    if (!this.id) return;
    this.loading = true;
    try { const response = await api.axios.get(`/api/whatsapp/campaigns/media/${this.id}`, { responseType: 'blob' }); if (version === this.requestVersion) this.url = URL.createObjectURL(response.data); }
    catch { if (version === this.requestVersion) this.error = true; }
    finally { if (version === this.requestVersion) this.loading = false; }
  } },
};
</script>
<style scoped>
.campaign-media img,.campaign-media video{display:block;max-width:100%;max-height:230px;border-radius:12px;object-fit:contain}.campaign-media{margin-bottom:12px;overflow-wrap:anywhere}
</style>
